import { render, staticRenderFns } from "./PreviewComponentFactory.vue?vue&type=template&id=2b84092b&"
import script from "./PreviewComponentFactory.vue?vue&type=script&lang=js&"
export * from "./PreviewComponentFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports